export const FeeType = { Offline: 1, Online: 2, Public: 3 }
export const FeeTypeText = { [FeeType.Offline]: '线下支付', [FeeType.Online]: '线上支付', [FeeType.Public]: '公对公打款' }